module.exports = __webpack_public_path__ + "img/SectionOnebg.bd45fb0a.png";